import Vue from "vue";

// Shared reactive queue of toast messages. The <app-toast> component (rendered
// once inside <v-app>) reads from this and shows them as Vuetify snackbars.
export const toastState = Vue.observable({
  items: [],
});

let nextId = 1;

function push(message, color, timeout) {
  if (!message) return;
  toastState.items.push({
    id: nextId++,
    message: typeof message === "string" ? message : String(message),
    color,
    timeout: timeout || 4000,
    show: true,
  });
}

export function dismissToast(id) {
  const index = toastState.items.findIndex((t) => t.id === id);
  if (index !== -1) {
    toastState.items.splice(index, 1);
  }
}

const toast = {
  success(message, timeout) {
    push(message, "success", timeout);
  },
  error(message, timeout) {
    push(message, "error", timeout);
  },
  info(message, timeout) {
    push(message, "info", timeout);
  },
  warning(message, timeout) {
    push(message, "warning", timeout);
  },
};

export default {
  install(VueInstance) {
    VueInstance.prototype.$toast = toast;
  },
};
